import http from 'hub-http/clients/apiClient';
import { mapCrmObjectData } from 'personalization-lib/utils/assetData/crm';
const BASE_URL = '/crm-search/search';
export const CRM_PROPERTIES = {
  NAME: 'hs_name',
  UPDATED_AT: 'hs_updated_at',
  CONTENT_ID: 'hs_content_id',
  PERSONALIZATION_VARIANT_STATUS: 'hs_personalization_variant_status',
  PERSONALIZATION_STRATEGY_ID: 'hs_personalization_strategy_id',
  SCREENSHOT_URL: 'hs_screenshot_url',
  CONTAINER_TYPE: 'hs_container_type',
  IS_SMART: 'hs_is_smart_cta',
  IS_ACTIVE_AB_TEST: 'hs_is_active_ab_test'
};
export const fetchCrmObjectsByType = ({
  objectTypeId,
  filters,
  properties = [CRM_PROPERTIES.NAME, CRM_PROPERTIES.SCREENSHOT_URL],
  search,
  offset,
  limit
}) => http.post(BASE_URL, {
  data: {
    objectTypeId,
    offset: offset !== null && offset !== void 0 ? offset : 0,
    count: limit !== null && limit !== void 0 ? limit : 10,
    query: search,
    filterGroups: [{
      filters
    }],
    requestOptions: {
      properties
    },
    sorts: [{
      property: CRM_PROPERTIES.UPDATED_AT,
      order: 'DESC'
    }]
  }
}).then(data => ({
  total: data.total,
  offset: data.offset,
  results: data.results.map(mapCrmObjectData)
}));